import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-help',
  imports: [
    CommonModule
  ],
  templateUrl: './help.component.html'
})
export class HelpComponent {
  
  helpItems = [
    { key: 'F1', description: 'Ajuda - Abre este menu de ajuda' },
    { key: 'F2', description: 'Cliente - Buscar cliente cadastrado' },
    { key: 'F3', description: 'Desconto - Aplicar desconto na venda' },
    { key: 'F4', description: 'Admin - Menu administrativo' },
    { key: 'F5', description: 'Finalizar - Finalizar venda e selecionar forma de pagamento' },
    { key: 'F6', description: 'Cancelar - Cancelar venda em andamento' },
    { key: 'F7', description: 'CPF/CNPJ - Entrada manual de cliente' },
    { key: 'F11', description: 'Produtos - Listar todos os produtos' },
    { key: 'ESC', description: 'Fechar - Fechar menu ou modal aberto' },
    { key: '↑ ↓', description: 'Navegar - Navegar entre os itens da venda' },
    { key: '+', description: 'Aumentar - Aumentar quantidade do item selecionado' },
    { key: '-', description: 'Diminuir - Diminuir quantidade do item selecionado' },
    { key: 'Delete', description: 'Remover - Remover item selecionado da venda' }
  ];

}
